import moment from "moment";
import { Cell, useBlockLayout, useRowSelect, useTable } from "react-table";
import { ModuSignTemplate } from "src/api/contract/modusign-types";
import { BaseButton, BaseRadio } from "src/components";
import { ArticleSection } from "src/components/layout/ArticleSection";
import { calculateTableWidth, ViewYmdFormat } from "src/utils";

const columns: any = [
  {
    Header: "템플릿명",
    accessor: "title",
    width: 380,
  },

  {
    Header: "문서 작성자 수",
    accessor: "participants",
    width: 160,
    Cell: ({ value }: Cell<ModuSignTemplate>) => {
      return <>{value && value.length + "명"}</>;
    },
  },
  {
    Header: "마지막 수정일",
    accessor: "updatedAt",
    width: 200,
    Cell: ({ value }: Cell<ModuSignTemplate>) => {
      return <>{value && moment(value).format(ViewYmdFormat.YYYY_MM_DD_HH_MM)}</>;
    },
  },
  {
    Header: "미리보기",
    accessor: "",
    width: 120,
    Cell: ({ row, getModuSignTemplatePreview }: Cell<ModuSignTemplate> & { getModuSignTemplatePreview: (templateId: string) => void }) => {
      return <BaseButton title="미리보기" className="color-white size-small" onClick={() => getModuSignTemplatePreview(row.original.id)} />;
    },
  },
];

type Props = {
  moduSignTemplates?: ModuSignTemplate[];
  getModuSignTemplatePreview: (templateId: string) => void;
  onSelectTemplate?: (selectedTemplate: ModuSignTemplate) => void;
  templateId?: string;
};

const ModuSignStep1 = ({ moduSignTemplates, getModuSignTemplatePreview, onSelectTemplate, templateId }: Props) => {
  // 테이블 설정
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
    {
      columns: columns as any,
      data: moduSignTemplates || [],
      getModuSignTemplatePreview,
      templateId,
    },
    useBlockLayout,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns: Array<any>) => [
        {
          width: 80,
          Header: "선택",
          accessor: "checked",
          Cell: ({ row, disabledList, templateId }: any) => {
            return (
              <BaseRadio
                id={row.id}
                // checked={row.original.id === templateId}
                onChange={(_: boolean) => {
                  onSelectTemplate?.(row.original);
                }}
                name="selectedProvider"
              />
            );
          },
        },
        ...columns,
      ]);
    },
  );

  return (
    <ArticleSection title="템플릿 선택" className="pb0">
      {/* <section className="base-abstract-modal__contents-subtitle ">
        <h2>템플릿 선택</h2>
      </section> */}
      <ul className="base-list mb30">
        <li>템플릿 추가를 원하실 경우, 파일을 contact@ppoint.kr로 보내주세요.</li>
        <li>템플릿 추가에 따른 데이터 연동은 별도 비용이 발생합니다.</li>
      </ul>

      <div className="flex-row d-flex flex-center-start">
        <div {...getTableProps()} className="base-table sticky overflow-x-hidden">
          <div className="header">
            {headerGroups.map((headerGroup) => (
              <div {...headerGroup.getHeaderGroupProps()} className="base-table__tr">
                {headerGroup.headers.map((header) => {
                  return (
                    <div {...header.getHeaderProps()} className="base-table__th">
                      {header.render("Header")}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
          <div {...getTableBodyProps()} className="body">
            {rows.map((row: any) => {
              prepareRow(row);

              return (
                <div {...row.getRowProps()} className={`base-table__tr`}>
                  {row.cells &&
                    row.cells.map((cell: any, index: number) => {
                      return (
                        <div {...cell.getCellProps()} className="base-table__td">
                          <div>{cell.render("Cell")}</div>
                        </div>
                      );
                    })}
                </div>
              );
            })}
            <div>
              {rows.length === 0 && (
                <div className="base-table__tr table-cursor-unset" style={{ width: calculateTableWidth(columns) }}>
                  <div className="base-table__td w-100 text-center">
                    <div className="w-100">{<span>데이터가 없습니다.</span>}</div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </ArticleSection>
  );
};

export default ModuSignStep1;
